import type { IUser } from './User';

export type DemoLinkAssetType = 'demo' | 'playbook';

export enum DemoLinkPlatform {
  web = 'web',
  desktop = 'desktop',
}
export enum DemoLinkAccessPolicy {
  WORKSPACE_RESTRICTED = 'workspace_restricted',
  PERMISSIVE = 'permissive',
  JOIN_TO_WORKSPACE = 'join_to_workspace',
}

export type DemoLinkAsset = {
  id: string;
  type: DemoLinkAssetType;
  revisionId: number;
  autoSync: boolean;
};

export type DemoLink = {
  id: string;
  organizationId: string;
  isDeleted: boolean;
  createTime: string;
  updateTime: string;
  archiveTime: string;
  creator: IUser;
  enabled: boolean;
  platform: DemoLinkPlatform;
  withGiveADemo: boolean;
  asset: DemoLinkAsset;
  allowSignUp: boolean;
  accessPolicy: DemoLinkAccessPolicy;
  token: string;
  inviteLinkId: string;
  workspaceId: string;
  url?: string;
  showGuidanceTooltip?: boolean;
};

export interface DemoLinkMetadata {
  assetName: string;
  organizationLogo?: string;
  organizationId: string;
  inviteLinkToken: string;
}

export type DemoLinkAccessPolicyType = DemoLinkAccessPolicy;
export type DemoLinkPlatformType = DemoLinkPlatform;
